import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Bietet ihr eine kostenlose Erstberatung an?",
    a: "Ja. Das erste Gespräch ist für Sie kostenlos und unverbindlich. Wir klären Ihr Vorhaben, mögliche Wege der Umsetzung und den weiteren Ablauf.",
  },
  {
    q: "In welchen Regionen arbeitet ihr?",
    a: "Wir sind in Bremen, Bremen-Nord und im direkten Umland tätig. Fragen Sie kurz an – wir sagen Ihnen offen, ob Ihr Ort im Einsatzgebiet liegt.",
  },
  {
    q: "Welche Gartenarbeiten bietet ihr an?",
    a: "Gartenplanung, Landschaftsbau, Terrassen, Pflaster- und Wegebau, Bepflanzung mit Gräsern, Hecken und Bäumen sowie regelmäßige Gartenpflege.",
  },
  {
    q: "Kann ich Fotos meines Gartens schicken?",
    a: "Gerne. Senden Sie uns Ihre Fotos direkt per WhatsApp – so können wir Ihr Projekt schon vor dem ersten Termin gut einschätzen.",
  },
  {
    q: "Kann ich direkt über WhatsApp Kontakt aufnehmen?",
    a: "Ja, WhatsApp ist der schnellste Weg zu uns. Ein Klick auf den Button unten rechts öffnet den Chat mit einer vorbereiteten Nachricht.",
  },
  {
    q: "Übernehmt ihr auch die regelmäßige Gartenpflege?",
    a: "Auf Wunsch betreuen wir Ihren Garten dauerhaft – von Rasenpflege über Heckenschnitt bis zur saisonalen Pflege.",
  },
];

export const FaqSection = () => (
  <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
    {FAQS.map((f, i) => (
      <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#17251C]/14">
        <AccordionTrigger
          data-testid={`faq-trigger-${i}`}
          className="py-7 text-left font-display text-base font-semibold text-[#17251C] transition-colors hover:text-[#B4623C] hover:no-underline md:text-lg"
        >
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="pb-7 text-base leading-relaxed text-[#6E7A69]">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
